import { getHook, setHook } from "react-hooks-outside";
import { useNavigate } from "react-router-dom";

setHook("navigate", useNavigate);

export const goToRoute = (path: string) => {
  const navigate = getHook("navigate");
  navigate(path);
};
